import type { ClassAttributes, ComponentType, HTMLAttributes } from 'react';

import { css, styled, type StyledProps } from '@compiled/react';

import { token } from '@atlaskit/tokens';

const commonSmartlinkOverrideStyles = css({
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/design-system/no-nested-styles -- Ignored via go/DSP-18766
	'& div[data-smart-link-container]': {
		boxSizing: 'border-box',

		// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
		"& div[data-smart-block]:not(:has(div[data-smart-element-media='image']))": {
			flexShrink: 0,
		},
		// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
		"& div[data-smart-block]:first-of-type:not(:has(span[data-vc='emoji-component'])):has(img)": {
			height: '100%',
			flexShrink: 1,
			// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/design-system/no-nested-styles -- Ignored via go/DSP-18766
			'& div[data-smart-element-media]': {
				height: '100%',
			},
		},
	},
});

type StyledCommonCarouselWrapperStyles =ComponentType<{
    isHero?: boolean;
    isSelected?: boolean;
} & ClassAttributes<HTMLDivElement> & HTMLAttributes<HTMLDivElement> & StyledProps>;

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const CommonCarouselWrapperStyles: StyledCommonCarouselWrapperStyles = styled.div<{
	isHero?: boolean;
	isSelected?: boolean;
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
}>(commonSmartlinkOverrideStyles, {
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
	'& div[data-smart-link-container]': {
		// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
		border: ({ isSelected }) =>
			isSelected
				? `${token('border.width')} ${token('color.border.selected')} solid`
				: `${token('border.width')} ${token('color.border')} solid`,
		'&:hover': {
			// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
			cursor: ({ isHero }) => (isHero ? 'cursor' : 'pointer'),
		},
	},
});

type StyledNavigationThumbnailWrapperStyles = ComponentType<{
    hasRoundedCorners?: boolean;
    height: number;
    maxWidth: number;
    minWidth: number;
} & ClassAttributes<HTMLDivElement> & HTMLAttributes<HTMLDivElement> & StyledProps>;

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const NavigationThumbnailWrapper: StyledNavigationThumbnailWrapperStyles = styled.div<{
	hasRoundedCorners?: boolean;
	height: number;
	maxWidth: number;
	minWidth: number;
}>({
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
	'& div[data-smart-link-container]': {
		overflow: 'hidden',
		flexShrink: 1,
		flexDirection: 'row',
		// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
		height: ({ height }) => `${height}px`,
		// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
		minWidth: ({ minWidth }) => `${minWidth}px`,
		// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
		maxWidth: ({ maxWidth }) => `${maxWidth}px`,
		marginRight: '0px',
		marginLeft: '0px',
		justifyContent: 'flex-start',
		alignItems: 'center',
		cursor: 'pointer',
		'--preview-block-width': token('space.600'),
		// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
		borderRadius: ({ hasRoundedCorners }) => (hasRoundedCorners ? '4px' : 0),
		// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
		paddingLeft: `calc(var(--preview-block-width) + ${token('space.050')})`,
	},
});
